(() => {
  if (window.KoraCardVariantsLoaded) return;
  window.KoraCardVariantsLoaded = true;

  const swatchSelector = '.kora-card-variant[data-kora-preview-src]';

  const previewVariant = (swatch) => {
    const card = swatch.closest('.kora-variant-enabled-card');
    const image = card?.querySelector('.card__media .media > img:first-child');
    const previewSrc = swatch.dataset.koraPreviewSrc;
    if (!card || !image || !previewSrc) return;

    if (!image.dataset.koraOriginalSrc) {
      image.dataset.koraOriginalSrc = image.getAttribute('src') || '';
      image.dataset.koraOriginalSrcset = image.getAttribute('srcset') || '';
    }

    image.setAttribute('src', previewSrc);
    image.setAttribute('srcset', previewSrc);
    card.classList.add('kora-preview-active');
    card.querySelectorAll('.kora-card-variant.is-preview').forEach((item) => item.classList.remove('is-preview'));
    swatch.classList.add('is-preview');
  };

  const restoreCard = (row) => {
    const card = row?.closest('.kora-variant-enabled-card');
    const image = card?.querySelector('.card__media .media > img:first-child');
    if (!card || !image || !image.dataset.koraOriginalSrc) return;

    image.setAttribute('src', image.dataset.koraOriginalSrc);
    if (image.dataset.koraOriginalSrcset) {
      image.setAttribute('srcset', image.dataset.koraOriginalSrcset);
    } else {
      image.removeAttribute('srcset');
    }
    card.classList.remove('kora-preview-active');
    card.querySelectorAll('.kora-card-variant.is-preview').forEach((item) => item.classList.remove('is-preview'));
  };

  document.addEventListener('pointerover', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (swatch) previewVariant(swatch);
  });

  document.addEventListener('focusin', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (swatch) previewVariant(swatch);
  });

  document.addEventListener('pointerout', (event) => {
    const row = event.target.closest('.kora-card-variants');
    if (row && (!event.relatedTarget || !row.contains(event.relatedTarget))) restoreCard(row);
  });

  document.addEventListener('focusout', (event) => {
    const row = event.target.closest('.kora-card-variants');
    if (row && (!event.relatedTarget || !row.contains(event.relatedTarget))) restoreCard(row);
  });
})();
